import { inject } from 'vue';
import type { GrantedContext } from './useIsGranted';

/** Vrai si la route nommée est accessible — sert à filtrer les entrées de menu. */
export function useRouteGranted(): (routeName: string) => boolean {
	const granted = inject<GrantedContext>('granted');
	return (routeName) => granted?.routeGranted(routeName) ?? false;
}
